// extracted by mini-css-extract-plugin
module.exports = {"ArticleForm":"ArticleForm_ArticleForm__1xNNJ","SubmitBtn":"ArticleForm_SubmitBtn__1PLHc"};